import { useEffect, useState } from "react";
import styles from "./TextCycler.module.scss";
type TextCyclerProps = {
  messages: string[];
  intervalMs?: number;
};
export const TextCycler = ({
  messages,
  intervalMs = 2500
}: TextCyclerProps) => {
  const [index, setIndex] = useState(0);
  useEffect(() => {
    if (messages.length <= 1) return;
    const id = setInterval(() => {
      setIndex(i => (i + 1) % messages.length);
    }, intervalMs);
    return () => clearInterval(id);
  }, [messages.length, intervalMs]);
  if (!messages.length) return null;
  return <span className={styles.progressMessage} data-sentry-component="TextCycler" data-sentry-source-file="TextCycler.tsx">{messages[index % messages.length]}</span>;
};